<div class="container">
    <img src="https://storage.googleapis.com/rxbc-pyxis-ui/content/img/RelayHealthLogo.gif"
        sizes="(max-width: 800px) 800px, 400px" priority class="center">
    <mat-label class="custom-label"><h1>
        You are not authorized to view this page. Please contact admin</h1>
    </mat-label>
</div>